import React, { Component } from 'react'
import PropTypes from 'prop-types'

import LinkPreviousIcon from 'grommet/components/icons/base/LinkPrevious'

import '../styles/BackButton.css'

class BackButton extends Component {
  _backClick () {
    this.props.history.goBack()
  }

  render () {
    if (this.props.isRoot) return null
    return (
      <div
        style={this.props.style}
        className='BackButton'
        onClick={() => this._backClick()}>
        <LinkPreviousIcon /> Back
      </div>
    )
  }
}

BackButton.defaultProps = {
  style: {}
}

BackButton.propTypes = {
  history: PropTypes.object,
  isRoot: PropTypes.bool,
  style: PropTypes.object
}

export default BackButton



// WEBPACK FOOTER //
// ./src/components/BackButton.js